/*
 * @Author: your name
 * @Date: 2021-07-09 14:21:06
 * @LastEditTime: 2022-06-15 14:27:11
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\router\router.js
 */
import Layout from "@/layout/index.vue";
import screenLayout from "@/views/screenHome/layout/index.vue";

const modules = require.context("./modules", true, /\.js$/);
const routeModuleMap = [];
modules.keys().forEach(key => {
  const mod = modules(key).default || modules(key);
  routeModuleMap.push(...mod);
});

const routes = [{
    path: "/",
    name: "index",
    meta: {
      title: "layout"
    },
    redirect: window.routerPush,
    component: Layout,
    children: [
      // {
      //   path: "Home",
      //   name: "Home",
      //   component: () => import("@/views/Home.vue"),
      //   meta: {
      //     title: "首页"
      //   }
      // },
      // {
      //   path: "communityKanbans",
      //   name: "communityKanbans",
      //   component: () => import("@/views/communityKanban/communityKanban.vue"),
      //   meta: {
      //     title: "社区看板"
      //   }
      // }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import ("@/views/system/login.vue"),
    meta: {
      title: "login"
    }
    // redirect: "/login"
    // component: Layout,
    // children: []
  },
  {
    path: "/downCenter",
    name: "downCenter",
    component: () =>
      import ("@/views/system/downCenter.vue"),
    meta: {
      title: "下载中心",
      hideBreadcrumb: true
    }
    // redirect: "/login"
    // component: Layout,
    // children: []
  },
  {
    path: "/404",
    name: "404",
    component: () =>
      import ("@/views/system/error-page/404.vue"),
    meta: {
      title: "404",
      hideBreadcrumb: true
    }
  },
  {
    path: "/*",
    name: "errorPage",
    redirect: "/404",
    meta: {
      title: "errorPage"
    }
  },
  {
    path: "/screenHome",
    name: "screenHome",
    component: screenLayout,
    meta: {
      title: "大屏投屏"
    },
    redirect: "/screenHome/screen",
    children: [{
      path: "screen",
      name: "screenHome",
      component: () =>
        import ("@/views/screenHome/index.vue"),
      meta: {
        title: "大屏首页"
      }
    }]
  },
  {
    path: "/keyControl",
    name: "keyControl",
    component: () =>
      import ("@/views/monitorManagement/keyControl/index.vue"),
    meta: {
      title: "重点管控",
    }
    // redirect: "/login"
    // component: Layout,
    // children: []
  },
];
// 用来判断是外网还是内网然后给他赋值
if (window.lgoinList) {
  routes[0].children.push({
    path: "Home",
    name: "Home",
    component: () =>
      import ("@/views/Home.vue"),
    meta: {
      title: "首页"
    }
  });
} else {
  routes[0].children.push({
    path: "communityKanbans",
    name: "communityKanbans",
    component: () =>
      import ("@/views/communityKanban/communityKanban.vue"),
    meta: {
      title: "首页"
    }
  });
}
export default routes;